module.exports = __webpack_public_path__ + "assets/Social-round-twitter.c99dfa7b.svg";